import { ChainId_Internal } from '../types';
export const TOPUP_SC_BY_CHAIN = {
    [ChainId_Internal.ZK_EVM]: '0x5d1Ad1190880B0a56C1fACF85f4894d58D0Cb21D',
    [ChainId_Internal.ZK_EVM_TEST]: '0xc82A1E0DAA5E5435A7B73ef33DdEb7a673930117',
    [ChainId_Internal.CRONOS_EVM_MAINNET]: '0x811fcD44bB4B32Ed09f45A6FC26a23BF7Ac4c12a',
    [ChainId_Internal.CRONOS_EVM_TESTNET]: '0x6840eF417eB13Ee5CC1c923f1f02825555997475',
    [ChainId_Internal.ETHEREUM]: '',
    [ChainId_Internal.SEPOLIA]: '',
};
export const SWAP_AND_TOPUP_SC_BY_CHAIN = {
    [ChainId_Internal.ZK_EVM]: '0x4c9d6021635BBcE572f31B6f8b04C1eB19557A6F',
    [ChainId_Internal.ZK_EVM_TEST]: '0x33a79ab99c225B031E980406Fd8328BE4487421D',
    [ChainId_Internal.CRONOS_EVM_MAINNET]: '0xBB9Bb871c1f5bB1F08E8a59C8f7AA6EF1637793B',
    [ChainId_Internal.CRONOS_EVM_TESTNET]: '0xF14B0CeD8276eAfB00198cCC67e1eD7489557D4B',
    [ChainId_Internal.ETHEREUM]: '',
    [ChainId_Internal.SEPOLIA]: '',
};
